import { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import Splash from "../../pages/Splash";

const FetchLoader = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    isFileUpload: false,
  });

  const listener = (e) => {
    let { detail } = e;
  
    let { isFileUpload, isOpen } = detail;
    console.log("Fetch-Loader event dispatched.......",{isFileUpload,isOpen});

    setModalState({ isFileUpload:isFileUpload, isOpen:isOpen });
  };

  useEffect(() => {
    window.addEventListener("FETCH-CYCLE", listener);

    return () => window.removeEventListener("FETCH-CYCLE", listener);
  }, []);

  if (modalState?.isOpen)
    return (
      <>
        <Splash
          message={
            modalState?.isFileUpload
              ? "Please wait , uploading files..."
              : null
          }
        />
      </>
    );
};

export default FetchLoader;
